<script setup name="Template6">
import { inject } from "vue";
import ContainerCom from "./ContainerCom.vue";
import TextCom from "./TextCom.vue";

// 为模板组件定义属性
const props = defineProps({
  templateId: {
    type: String,
    default: "",
  },
});
const isLoggedIn = inject("isLoggedIn");
// 处理删除事件
const handleDelete = (contentId) => {
  // emit删除事件
  emit("handleDelete", props.templateId);
};

// 定义emits
const emit = defineEmits(["edit", "handleDelete"]);
</script>

<!-- 添加组件描述注释 -->
<!-- 6号模板组件：技术原理页面，包含标题、描述、图表和数据指标 -->

<template>
  <div class="template-6" ref="templateRef" :class="{ 'fade-in': isVisible }">
    <!-- 删除按钮 -->
    <el-icon
      class="order-number"
      color="#222"
      size="20"
      @click="emit('order', $event)"
      v-if="isLoggedIn"
    >
      <DCaret />
    </el-icon>
    <el-icon class="delete-button" @click="handleDelete" v-if="isLoggedIn">
      <Delete />
    </el-icon>
    <div class="top-content">
      <div class="left-content">
        <div class="left-content-wrap">
          <TextCom :contentId="`${props.templateId}-text-1`" />
          <TextCom class="title" :contentId="`${props.templateId}-text-2`" />
          <TextCom :contentId="`${props.templateId}-text-3`" />
        </div>
      </div>
      <div class="right-content">
        <div class="right-content-img">
          <ContainerCom
            :contentId="props.templateId + '-container-1'"
          ></ContainerCom>
        </div>
        <div class="right-content-text">
          <TextCom :contentId="`${props.templateId}-text-4`" />
        </div>
      </div>
    </div>
    <div class="bottom-content">
      <div class="bottom-content-item" v-for="i in 6" :key="i">
        <TextCom :contentId="`${props.templateId}-text-${i * 2 + 3}`" />
        <TextCom :contentId="`${props.templateId}-text-${i * 2 + 4}`" />
      </div>
    </div>
  </div>
  <!-- 使用ContainerCom作为主容器 -->
</template>

<style scoped>
.template-6 {
  width: 100vw;
  /* height: 100vh; */
  min-height: 70vh;
  background-color: #eef0f6;
  padding: 3.64vw 4.06vw;
  position: relative;
  display: flex;
  flex-direction: column;
  /* 移动端适配：调整字体大小和内边距 */
  @media (max-width: 768px) {
    font-size: 14px;
    padding: 5vw 4vw;
  }
}
.top-content {
  height: 30.46vw;
  display: flex;
  background-color: #fff;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  /* 移动端适配：改为垂直排列 */
  @media (max-width: 1024px) {
    height: 100vh;
    flex-direction: column;
    /* align-items: stretch; */
  }
}
.title {
  /* transform: translateY(-20px); */
  margin-bottom: 30px;
  /* 移动端适配：调整边距 */
  @media (max-width: 768px) {
    margin-bottom: 20px;
    /* transform: translateY(-10px); */
  }
}
.order-number {
  position: absolute;
  top: 20px;
  right: 40px;
  border: none;
  padding: 2px;
  /* padding: 8px 16px; */
  border-radius: 4px;
  cursor: pointer;
  /* font-size: 14px; */
  transition: all 0.3s ease;
  z-index: 1000;
  margin-right: 8px;
  background-color: #fff;
}
.order-number:hover {
  background-color: #fff;
  transform: scale(1.05);
}
.left-content {
  display: flex;
  flex-direction: column;
  margin-left: 8.07vw;
  /* max-width: 25.83vw; */
  width: 50%;
  /* 移动端适配：调整边距 */
  @media (max-width: 1024px) {
    margin: 0 5vw;
    padding: 2rem 0;
    width: 100%;
  }
  @media (max-width: 768px) {
    margin: 0 3vw;
    padding: 1.5rem 0;
    width: 100%;
  }
}
.left-content-wrap {
  max-width: 25.83vw;
  display: flex;
  flex-direction: column;
  width: 100%;


  @media (max-width: 1024px) {
    max-width: 100%;
      padding: 0 2rem;
      text-align: center;
  }
}
.right-content {
  /* padding: 3rem 3rem 1rem; */
  width: 50%;
  /* PC端：确保右边内容占满空间 */
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 移动端适配：调整内边距 */
  @media (max-width: 1024px) {
    width: 100%;
    padding: 0 5vw 2rem;
  }
  @media (max-width: 768px) {
    padding: 0 3vw 1.5rem;
    width: 100%;
  }
}
.right-content-img {
  /* PC端：占满右边内容的空间 */
  width: 100%;
  height: 23.8542vw;
  /* 确保容器能占满空间 */
  max-width: 100%;
  /* 移动端适配：改为相对宽高 */
  @media (max-width: 1024px) {
    width: 100%;
    height: 350px;
  }
  @media (max-width: 768px) {
    width: 100%;
    /* 改为自适应高度，让图片决定高度 */
    height: 200px;
    /* 或者设置一个最小高度 */
    /* min-height: 200px; */
  }
}

/* 确保视频背景也能正确显示 */
.right-content-img :deep(video) {
  /* 确保视频能自适应容器 */
  width: 100% !important;
  /* height: auto !important; */
  object-fit: cover !important;
}
.right-content-text {
  margin-top: 2rem;
  text-align: center;
  /* 移动端适配：调整边距 */
  @media (max-width: 768px) {
    margin-top: 1.5rem;
  }
}
.bottom-content {
  display: flex;
  margin-top: 1.5rem;
  width: 100%;
  /* 保持PC端不换行 */
  /* 移动端适配：添加换行 */
  @media (max-width: 1024px) {
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 1rem;
    /* gap: 10px; */
  }
}
/* 删除按钮 */
.delete-button {
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: #f56c6c;
  color: #fff;
  border: none;
  padding: 2px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 20px;
  transition: all 0.3s ease;
  z-index: 1000;
  /* 移动端适配：调整大小和位置 */
  @media (max-width: 768px) {
    top: 10px;
    right: 10px;
    font-size: 18px;
  }
}
.delete-button:hover {
  background-color: #f78989;
  color: white;
  transform: scale(1.05);
}

.bottom-content-item {
  background-color: #fff;
  padding: 3.13vw 0 3.13vw 2.7083vw;
  margin-right: 10px;
  /* 保持PC端原有样式：6个元素一行 */
  min-width: 200px;
  width: 16.66%;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* 移动端适配：调整样式 */
  @media (max-width: 1024px) {
    /* 平板端：3个元素一行 */
    width: calc(33.33% - 6.66px);
    /* min-width: calc(33.33% - 10px); */
    margin-bottom: 10px;
  }
  @media (max-width: 768px) {
    /* 移动端：2个元素一行 */
    padding: 1rem;
    width: calc(50% - 10px);
    min-width: calc(50% - 10px);
    margin-right: 0;
  }
  @media (max-width: 480px) {
    /* 小移动端：1个元素一行 */
    width: 100%;
    min-width: 100%;
  }
}
/* 保持PC端原有样式：最后一个元素无边距 */
.bottom-content-item:last-child {
  margin-right: 0;
}
/* 移动端适配：调整间距 */
@media (max-width: 1024px) {
  /* 平板端：每3个元素一组，最后一个元素无边距 */
  .bottom-content-item:nth-child(3n) {
    margin-right: 0;
  }
}
@media (max-width: 768px) {
  /* 移动端：每2个元素一组，最后一个元素无边距 */
  .bottom-content-item:nth-child(2n) {
    margin-right: 0;
  }
}
/* 小移动端：每个元素独占一行 */
@media (max-width: 480px) {
  .bottom-content-item {
    margin-right: 0;
  }
}
</style>
